import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetReleasesQuery } from "./releasesSlice";
import { format } from "date-fns";
import { Loader } from "../../components/common/Loader/Loader";
import toast, { Toaster } from "react-hot-toast";

const ReleaseNotes = () => {
  const navigate = useNavigate();
  const [releases, setReleases] = useState();

  const { data, isLoading, error } = useGetReleasesQuery();

  useEffect(() => {
    if (data) {
      const loadedData = data.ids.map((id) => data.entities[id]);
      setReleases(loadedData);
    }
    if (error) {
      toast.error(error?.data?.Message || "Something Went Wrong...!");
    }
  }, [data, error]);

  return (
    <>
      <h1 className="mb-5">Release Notes</h1>
      <Toaster position="top right" />
      {isLoading ? (
        <Loader />
      ) : error ? (
        error?.data?.Message || "Something Went Wrong...!"
      ) : (
        ""
      )}
      <div className="row">
        {releases?.map((release) => (
          <div key={release.id} className="col-xs-12 col-sm-12 col-md-3">
            <div className="note-card mb-4">
              <h6
                className="version"
                role="button"
                onClick={() => navigate(`/release-notes/${release.id}`)}
              >
                {release?.version}
              </h6>
              <p>{release?.description}</p>
              <span>
                Released:
                {release?.dueDate
                  ? format(new Date(release?.dueDate), "MMMM dd, yyyy")
                  : "N/A"}
              </span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ReleaseNotes;
